import { ErrorContainer, ErrorDesc, ErrorOps } from './ErrorFallback.styles';
import React from 'react';

type ErrorFallbackProps = {
  className?: string;
  children?: React.ReactNode;
};

const ErrorFallback = (props: ErrorFallbackProps) => {
  const { className } = props;

  return (
    <ErrorContainer className={className}>
      <ErrorOps>{`Oops...`}</ErrorOps>
      <ErrorDesc>{`Looks like something went wrong.`}</ErrorDesc>
      <ErrorDesc>{`We're working on it.`}</ErrorDesc>
    </ErrorContainer>
  );
};

export default ErrorFallback;
